import { publicApi } from './api.service';

/**
 * Announcements published from the admin panel.
 *
 * Banners are deliberately not consumed here: there is no spare room on a trading
 * screen, and the placements (dashboard, marketplace, login side) all belong to the
 * customer portal.
 */

export type AnnouncementSeverity = 'INFO' | 'SUCCESS' | 'WARNING' | 'CRITICAL';

export interface SiteAnnouncement {
  id: string;
  title: string;
  /** Plain text by design -- render as a text node, never as HTML. */
  body: string;
  severity: AnnouncementSeverity;
  ctaLabel: string | null;
  ctaUrl: string | null;
  isDismissible: boolean;
  priority: number;
}

export interface AnnouncementsResponse {
  success: boolean;
  data: SiteAnnouncement[];
  total: number;
}

/**
 * `publicApi` is baseURL'd at VITE_API_BASE_URL (`.../api/`); axios joins the two, so
 * the leading slash here is fine and matches the other services in this app.
 */
export async function getAnnouncements(authenticated: boolean): Promise<AnnouncementsResponse> {
  const response = await publicApi.get<AnnouncementsResponse>('/v1/announcements', {
    params: { authenticated },
  });
  return response.data;
}
